module.exports = __webpack_public_path__ + "static/SerpentineSection-mobile-b73f17fd7eb4011847e54c16a382433f.jpg";